import moment from 'moment';

import { ACTIONS } from '@~/actions/completion-ceremony';

const initialState = {
  eventType: null,
  eventTime: '',
};

export default function defaultExport(state = initialState, { type, payload }) {
  switch (type) {
    case ACTIONS.TRIGGER_COMPLETION_CEREMONY_EVENT: {
      const { eventData } = payload;
      const { message } = eventData || {};

      return {
        message,
        eventTime: String(Number(moment())),
      };
    }
    default:
      return state;
  }
}
